// Allowed dash and underscore ranges
const dashAndUnderscoreRanges: [number, number][] = [
  [0x002d, 0x002d], // Hyphen-minus
  [0x005f, 0x005f], // Underscore
  [0x2012, 0x2015], // Unicode dashes
  [0x2053, 0x2053] // Swung dash
];

// Ideographic ranges (from your Go code)
const ideographicRanges: [number, number][] = [
  [0x3006, 0x3007],
  [0x3021, 0x3029],
  [0x3038, 0x303a],
  [0x3400, 0x4dbf],
  [0x4e00, 0x9fff],
  [0xf900, 0xfa6d],
  [0xfa70, 0xfad9],
  [0x16fe4, 0x17000],
  [0x17001, 0x187f7],
  [0x18800, 0x18cd5],
  [0x18d00, 0x18d08],
  [0x1b170, 0x1b2fb],
  [0x20000, 0x2a6df],
  [0x2a700, 0x2b739],
  [0x2b740, 0x2b81d],
  [0x2b820, 0x2cea1],
  [0x2ceb0, 0x2ebe0],
  [0x2f800, 0x2fa1d],
  [0x30000, 0x3134a],
  [0x31350, 0x323af]
];

// Helper: check if code point is in any given range
function inRanges(codePoint: number, ranges: [number, number][]): boolean {
  return ranges.some(([start, end]) => codePoint >= start && codePoint <= end);
}

// Helper: check Unicode category using property escapes
function isSpace(cp: number): boolean {
  return /\p{White_Space}/u.test(String.fromCodePoint(cp));
}
function isPunct(cp: number): boolean {
  return /\p{P}/u.test(String.fromCodePoint(cp));
}
function isMark(cp: number): boolean {
  return /\p{M}/u.test(String.fromCodePoint(cp));
}
function isLetter(cp: number): boolean {
  return /\p{L}/u.test(String.fromCodePoint(cp));
}
function isNumber(cp: number): boolean {
  return /\p{N}/u.test(String.fromCodePoint(cp));
}

export function replaceValidUnicodeString(s: string): string {
  let text = '';
  for (const char of s) {
    const cp = char.codePointAt(0);

    // Allow dash and underscore ranges
    if (inRanges(cp, dashAndUnderscoreRanges)) {
      text += char;
      continue;
    }

    // Allow if letter, number, or ideographic
    if (isLetter(cp) || isNumber(cp) || inRanges(cp, ideographicRanges)) {
      text += char;
      continue;
    }
  }

  return text;
}

// Main validation function
export function isValidUnicodeString(s: string): boolean {
  for (const char of s) {
    const cp = char.codePointAt(0);
    if (!cp) return false;

    // Allow dash and underscore ranges
    if (inRanges(cp, dashAndUnderscoreRanges)) continue;

    // Reject if space, punctuation, or mark
    if (isSpace(cp) || isPunct(cp) || isMark(cp)) return false;

    // Allow if letter, number, or ideographic
    if (isLetter(cp) || isNumber(cp) || inRanges(cp, ideographicRanges)) continue;

    // Otherwise, reject
    return false;
  }
  return true;
}
